
const datamanagerperfomance = (state = [], action) => {
    switch (action.type) {
      case 'HANDLE_DATA_PERFOMANCE':
        return {...state, perfomance: action.post}
      case 'HANDLE_DATA_PERFOMANCE_COMPARE':
        return {...state, perfomance_compare: action.post}
      default:
        return state
    }
  }
  
  export default datamanagerperfomance